import { parseAsString, useQueryStates } from 'nuqs'

const getCurrentMonth = () => {
	const date = new Date()
	// Set to first day of current month
	date.setDate(1)
	return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function useDate() {
	const defaultDate = getCurrentMonth()
	const [queryState, setQueryState] = useQueryStates({
		date: parseAsString.withDefault(defaultDate),
	})

	return {
		date: queryState.date || defaultDate,
		setDate: (date: string | undefined) => {
			const newDate = date || defaultDate
			if (newDate !== queryState.date) {
				setQueryState({ date: newDate })
			}
		},
	}
}
